import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useSite } from "@/hooks/useSite";
import Home from "@/pages/Home";
import OurStory from "@/pages/OurStory";
import NotFound from "@/pages/NotFound";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const { data } = useSite();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    if (!data) return;
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView();
  }, [pathname, hash, data]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/admin/*" element={<Suspense fallback={null}><AdminApp /></Suspense>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
